import { createFileRoute } from '@tanstack/react-router'

import { TopupsPage } from '#/modules/wallets/topups-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/wallet-topups')({
  component: TopupsPage,
  validateSearch: validateListSearch,
})
